module.exports = __webpack_public_path__ + "static/media/apple_logo_purple.49d8a48e.svg";